import React from "react";
import { Box, Button, CardHeader, Divider, IconButton, Tooltip } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import SyncIcon from "@mui/icons-material/Sync";

import DistributionCompanySelect from "./DistributionCompanySelect";

/** Standard list header of the distribution portal: company select, «ایجاد» and refresh. */
const EDCListCardHeader = ({
  title,
  subheader,
  context,
  onCompanyChange,
  onCreate,
  createDisabled = false,
  onRefresh,
  busy = false,
}) => (
  <CardHeader
    title={title}
    subheader={subheader}
    action={
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
        <DistributionCompanySelect context={context} onChange={onCompanyChange} />
        {onCreate ? (
          <Button variant="contained" startIcon={<AddIcon />} onClick={onCreate} disabled={createDisabled}>
            ایجاد
          </Button>
        ) : null}
        <Divider orientation="vertical" variant="middle" flexItem />
        <Tooltip title="به‌روزرسانی">
          <span>
            <IconButton color="primary" onClick={onRefresh} disabled={busy}>
              <SyncIcon />
            </IconButton>
          </span>
        </Tooltip>
      </Box>
    }
  />
);

export default EDCListCardHeader;
